import classNames from 'classnames';
import { selectors } from './utils';
import { SwiperProps, Swiper as ReactSwiper } from 'swiper/react';

import './styles.css';

export function Swiper({
  className,
  children,
  ...rest
}: SwiperProps) {
  const classes = classNames('app-swiper', className);
  return (
    <ReactSwiper className={classes} {...rest}>
      {children}
    </ReactSwiper>
  );
}

export const SwiperOutNav = ({ id }: { id: string }) => {
  const btnPrev = selectors.btnPrev.replace('.', '').replace('{id}', String(id));
  const btnNext = selectors.btnNext.replace('.', '').replace('{id}', String(id));
  return (
    <div className="app-swiper-out-nav">
      <div className={'swiper-button-prev ' + btnPrev + ' swiper-out-btn'}></div>
      <div className={'swiper-button-next ' + btnNext + ' swiper-out-btn'}></div>
    </div>
  );
};

export { SwiperSlide } from 'swiper/react';
export type { SwiperProps, SwiperSlideProps } from 'swiper/react';
